var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('HeaderCom')],1),_c('el-main',{staticClass:"center",class:_vm.propClass},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }